export const FAST_REFRESH_RUNTIME_RELOAD =
  'Fast Refresh had to perform a full reload due to a runtime error.'
